import React from 'react';

import { VoiceBlob, type BlobState } from './Blob';

const BLOB_SIZE = 100;
const DOCK_HEIGHT = 130;

/** Mask stops: height 0/50/90/100% → opacity 0/70/100/100%. */
const DOCK_FADE_MASK =
  'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 50%, #000 90%, #000 100%)';

/**
 * `VoiceBottomDock` — 100×100 blob pinned above the footer while the call
 * is live. Status text lives in `ControlBar` (timer + waveform when idle).
 *
 * Overlays the bottom of the scroll list. A masked solid background fades
 * in from fully transparent at the top to opaque by mid-height so
 * transcripts soften into the dock; the blob stays fully opaque on top.
 */
export interface VoiceBottomDockProps {
  blobState: BlobState;
}

export const VoiceBottomDock: React.FC<VoiceBottomDockProps> = ({ blobState }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        height: DOCK_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      {/* Themed wash — mask reveals scroll content through the top half. */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background: 'var(--color-background, #FFFFFF)',
          WebkitMaskImage: DOCK_FADE_MASK,
          maskImage: DOCK_FADE_MASK,
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: BLOB_SIZE,
          height: BLOB_SIZE,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <VoiceBlob state={blobState} size={BLOB_SIZE} />
      </div>
    </div>
  );
};

export default VoiceBottomDock;
